import { ComboBox } from "@carbon/react";

export const Filter = ({ props }) => {
  const items = ["last 7 days", "last 1 month", "last 6 months"];

  return (
    <ComboBox
      onChange={() => {}}
      id="carbon-combobox"
      items={items}
      itemToString={(item) => (item ? item : "")}
      placeholder="last 7 days"
    />
  );
};
